import { getWindow } from '@ps/web-core-utils';
import { useEffect } from 'react';

import { inIframe } from '@swf/core/utils/inIframe';

type EventListener =
  | ((value?: string) => void)
  | ((value?: number) => void)
  | ((value?: boolean) => void);

const secureWindow = getWindow();
const useIFramePostMessage = (type: string, eventListenerAction: EventListener) => {
  const postMessage = (value?: string | number | boolean) => {
    if (inIframe()) {
      secureWindow?.parent.postMessage({ type, value }, secureWindow.document.referrer || '');
    }
  };

  useEffect(() => {
    const eventListener = (event: MessageEvent) => {
      if (event.data.type === type) {
        eventListenerAction(event.data.value);
      }
    };

    !inIframe() && secureWindow?.addEventListener('message', eventListener, false);

    return () => {
      if (!inIframe()) {
        secureWindow?.removeEventListener('message', eventListener);
      }
    };
  }, [eventListenerAction, type]);

  return { postMessage };
};

export default useIFramePostMessage;
